<template>
    <div class="dashboardCellArchive">
        <button class="ssa-button button-linkStyle"
                v-on:click="handleClick"
        >
            {{archivedText}}
        </button>
    </div>
</template>

<script>
export default {
    name: 'DashboardCellArchive',
    props: {
        archived: {
            type: Boolean
        },
        appKey: String,
        name: String
    },
    computed: {
        archivedText() {
            return this.archived ? 'Restore' : 'Archive';
        }
    },
    methods: {
        handleClick() {
            const data = {
                appKey: this.appKey,
                shouldArchive: !this.archived,
                appName: this.name
            };
            this.$emit('archiveClicked', data);
        }
    }
};
</script>

<style scoped>
</style>
